import { render, staticRenderFns } from "./qualityImprovementListB.vue?vue&type=template&id=25b7470b&scoped=true"
import script from "./qualityImprovementListB.vue?vue&type=script&lang=js"
export * from "./qualityImprovementListB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b7470b",
  null
  
)

export default component.exports